<template>
    <select v-model="selected_year">
        <option value="" selected>Select Year</option>
        <option v-for="year in years" :value="year">
            {{ year }}
        </option>
    </select>
</template>

<script>
export default {
    name: "SelectYear",
    data() {
        return {
            selected_year: "",
            years: this.getYears(),
        };
    },
    methods: {
        getYears() {
            var years = [];
            var year = new Date().getFullYear();

            for (var i = 0; i < 8; i++) {
                years.push(year + i);
            }

            return years;
        },
    },
};
</script>
